import { createTheme as createUiTheme } from "@scoutingops/ui";

import type { Direction, PrimaryColor, Theme } from "./types";

interface Config {
	primaryColor: PrimaryColor;
	direction?: Direction;
}

// Palette, shadows, typography, and component overrides all come from
// @scoutingops/ui, so this app renders the same design tokens as every other
// Scouting Ops app.
export function createTheme(config: Config): Theme {
	return createUiTheme(config) as Theme;
}
